module.exports = __webpack_public_path__ + "static/media/link.8810310c.svg";